import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { ArrowUpRight, MapPin, Phone, EnvelopeSimple, WhatsappLogo } from "@phosphor-icons/react";
import { BRAND } from "../data/content";
import { submitContatto } from "@/lib/api";

export default function ContattiPage() {
  const [searchParams] = useSearchParams();
  const prodotto = searchParams.get("prodotto");
  const [form, setForm] = useState({
    nome: "",
    email: "",
    telefono: "",
    citta: "",
    messaggio: prodotto
      ? `Buongiorno, vorrei ricevere maggiori informazioni e un preventivo per: ${prodotto}.`
      : "",
    hp: "",
  });
  const [loading, setLoading] = useState(false);

  // Se l'utente naviga verso /contatti?prodotto=... senza ricaricare (SPA nav),
  // aggiorno il messaggio a patto che il campo sia ancora vuoto o contenga il vecchio prefill.
  useEffect(() => {
    if (!prodotto) return;
    setForm((f) => {
      const prefill = `Buongiorno, vorrei ricevere maggiori informazioni e un preventivo per: ${prodotto}.`;
      const looksLikeOldPrefill = /^Buongiorno, vorrei ricevere maggiori informazioni e un preventivo per: /.test(f.messaggio);
      if (f.messaggio === "" || looksLikeOldPrefill) {
        return { ...f, messaggio: prefill };
      }
      return f;
    });
  }, [prodotto]);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nome || !form.email || !form.messaggio) {
      toast.error("Compila i campi obbligatori");
      return;
    }
    setLoading(true);
    try {
      await submitContatto(form);
      toast.success("Grazie! Ti contatteremo entro 24 ore.");
      setForm({ nome: "", email: "", telefono: "", citta: "", messaggio: "", hp: "" });
    } catch (err) {
      toast.error(err.message || "Errore nell'invio. Riprova o chiamaci direttamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="contact-page" className="pt-[140px] pb-20">
      <div className="max-w-[1480px] mx-auto px-5 sm:px-8 lg:px-12">
        <div className="overline mb-6">Contatti</div>
        <h1 className="font-display text-[clamp(2.8rem,7vw,6.5rem)] leading-[0.9] tracking-tighter font-medium max-w-4xl">
          Parliamo del tuo <em className="italic font-light text-[#EB0D0D]">progetto</em>.
        </h1>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mt-20">
          <div className="lg:col-span-5">
            <div className="space-y-8">
              <div>
                <div className="flex items-center gap-3 mb-2">
                  <MapPin size={20} className="text-[#EB0D0D]" weight="duotone" />
                  <div className="text-xs uppercase tracking-[0.2em] text-[#5C5A55]">Showroom</div>
                </div>
                <div className="font-display text-xl">{BRAND.address}</div>
                <div className="text-sm text-[#5C5A55] mt-1">{BRAND.region}</div>
              </div>

              <div>
                <div className="flex items-center gap-3 mb-2">
                  <Phone size={20} className="text-[#EB0D0D]" weight="duotone" />
                  <div className="text-xs uppercase tracking-[0.2em] text-[#5C5A55]">Telefono</div>
                </div>
                <a href={`tel:${BRAND.phoneClean}`} className="font-display text-xl hover:text-[#EB0D0D] transition-colors">{BRAND.phone}</a>
              </div>

              <div>
                <div className="flex items-center gap-3 mb-2">
                  <EnvelopeSimple size={20} className="text-[#EB0D0D]" weight="duotone" />
                  <div className="text-xs uppercase tracking-[0.2em] text-[#5C5A55]">Email</div>
                </div>
                <a href={`mailto:${BRAND.email}`} className="font-display text-xl hover:text-[#EB0D0D] transition-colors break-all">{BRAND.email}</a>
              </div>

              <a href={BRAND.whatsapp} data-testid="whatsapp-cta" className="inline-flex items-center gap-3 bg-[#2C4C3B] hover:bg-[#1A1918] text-[#FAF9F6] px-6 py-3 text-sm uppercase tracking-[0.15em] font-bold rounded-sm transition-all mt-4">
                <WhatsappLogo size={18} weight="bold" />
                Scrivici su WhatsApp
              </a>
            </div>
          </div>

          <div className="lg:col-span-7">
            <form onSubmit={submit} data-testid="contact-form" className="bg-[#F0EFEB] p-8 md:p-12 border border-[#D1CFC7]/40">
              <div className="overline mb-6">Form contatti</div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div className="md:col-span-2">
                  <label className="block text-xs uppercase tracking-[0.15em] font-bold mb-2 text-[#1A1918]">Nome *</label>
                  <input data-testid="contact-input-nome" required value={form.nome} onChange={(e) => setForm({ ...form, nome: e.target.value })} className="w-full bg-[#FAF9F6] border border-[#D1CFC7] px-4 py-3.5 text-base focus:outline-none focus:border-[#EB0D0D]" />
                </div>
                <div>
                  <label className="block text-xs uppercase tracking-[0.15em] font-bold mb-2 text-[#1A1918]">Email *</label>
                  <input type="email" data-testid="contact-input-email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-[#FAF9F6] border border-[#D1CFC7] px-4 py-3.5 text-base focus:outline-none focus:border-[#EB0D0D]" />
                </div>
                <div>
                  <label className="block text-xs uppercase tracking-[0.15em] font-bold mb-2 text-[#1A1918]">Telefono</label>
                  <input data-testid="contact-input-telefono" value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })} className="w-full bg-[#FAF9F6] border border-[#D1CFC7] px-4 py-3.5 text-base focus:outline-none focus:border-[#EB0D0D]" />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-xs uppercase tracking-[0.15em] font-bold mb-2 text-[#1A1918]">Città</label>
                  <input data-testid="contact-input-citta" value={form.citta} onChange={(e) => setForm({ ...form, citta: e.target.value })} className="w-full bg-[#FAF9F6] border border-[#D1CFC7] px-4 py-3.5 text-base focus:outline-none focus:border-[#EB0D0D]" />
                </div>
                <div className="md:col-span-2">
                  <label className="block text-xs uppercase tracking-[0.15em] font-bold mb-2 text-[#1A1918]">Messaggio *</label>
                  <textarea data-testid="contact-input-messaggio" required value={form.messaggio} onChange={(e) => setForm({ ...form, messaggio: e.target.value })} rows={5} className="w-full bg-[#FAF9F6] border border-[#D1CFC7] px-4 py-3.5 text-base focus:outline-none focus:border-[#EB0D0D] resize-none" />
                </div>
              </div>

              {/* Honeypot: campo nascosto ai visitatori umani; i bot lo compilano → scartiamo la submission lato server */}
              <input
                type="text"
                name="website"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                value={form.hp}
                onChange={(e) => setForm({ ...form, hp: e.target.value })}
                style={{ position: "absolute", left: "-9999px", width: "1px", height: "1px", opacity: 0 }}
              />

              <button type="submit" data-testid="contact-submit-btn" disabled={loading} className="btn-primary mt-8 disabled:opacity-50">
                {loading ? "Invio..." : "Invia richiesta"}
                <ArrowUpRight size={16} weight="bold" />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
